var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCppLanguageIcon = function SvgCppLanguageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 16,
    fill: "currentColor",
    fontFamily: "Onest, sans-serif",
    fontSize: 9.5,
    fontWeight: 800,
    textAnchor: "middle"
  }, "\n\t\tC++\n\t")));
};
export default SvgCppLanguageIcon;